import { useMutation } from '@tanstack/react-query';

import {
  type AiCodeContext,
  type AiCodeProgress,
  type AiCodeProposal,
  prepareAiCodeProposal,
  saveAiCodeProposal,
} from '~/services/PromoVoucherAiService';

type GenerateInput = { context: AiCodeContext; onProgress: AiCodeProgress };
type SaveInput = { proposal: AiCodeProposal; onProgress: AiCodeProgress };

export function usePromoVoucherAiWorkflow() {
  const generate = useMutation({
    mutationFn: ({ context, onProgress }: GenerateInput) => prepareAiCodeProposal(context, onProgress),
    retry: false,
  });
  const save = useMutation({
    mutationFn: ({ proposal, onProgress }: SaveInput) => saveAiCodeProposal(proposal, onProgress),
    retry: false,
  });

  return { generate, save };
}
